//* 조문객용 부고문자 컴포넌트
import { FC } from 'react';

import { BugoData } from '@shared/api/bugo/bugo.interface';
import { fileBucketUrl } from '@shared/utils/fileUtils';
import bottomBanner from 'src/assets/banner/bottomBanner.jpg';
import topLogo from 'src/assets/logo/topLogo.png';

import { ObituaryLayout } from './ObituaryLayout';

interface Props {
  bugo: BugoData;
  forMember?: boolean;
}

const Obituary: FC<Props> = function Obituary({ bugo, forMember }: Props) {
  const hardCustomConfig = bugo.fevent.hardCustomConfig;
  const useCustomConfig = hardCustomConfig?.useCustomConfig === true;
  const bugoBrand = bugo.bugoBrand;
  //* 조의금 사절은 지도사도 켜는 항목이라 꾸미기(useCustomConfig)와 무관하게 적용한다
  const condolenceMoneyProps = {
    hideCondolenceMoney: hardCustomConfig?.hideCondolenceMoney === true,
    condolenceMoneyMessage: hardCustomConfig?.condolenceMoneyMessage,
  };

  if (useCustomConfig) {
    return (
      <ObituaryLayout
        bugo={bugo}
        forMember={forMember}
        logoImage={
          hardCustomConfig?.headerImage
            ? fileBucketUrl(hardCustomConfig.headerImage.url, 'raw')
            : topLogo
        }
        footerImage={
          hardCustomConfig?.footerImage
            ? fileBucketUrl(hardCustomConfig.footerImage.url, 'raw')
            : bottomBanner
        }
        footerLink={bugoBrand?.bugoAgency?.homepageUrl}
        showFlower={hardCustomConfig?.hideFlowerOrderLink !== true}
        emptyAccountMessage={hardCustomConfig?.emptyAccountMessage}
        {...condolenceMoneyProps}
      />
    );
  }

  return (
    <ObituaryLayout
      bugo={bugo}
      forMember={forMember}
      logoImage={topLogo}
      footerImage={bottomBanner}
      footerLink={bugoBrand?.bugoAgency?.homepageUrl}
      showFlower={true}
      {...condolenceMoneyProps}
    />
  );
};

export default Obituary;
